module.exports = __webpack_public_path__ + "static/img/cart-empty.68edbf9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cart-empty.jpg
// module id = u7iE
// module chunks = 1